export default __webpack_public_path__ + "assets/cfbcb47f54ee68d056caaf76d17972b0.svg";